var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"ms-storage-image",attrs:{"src":_vm.imageSrc,"width":_vm.computedWidth,"height":_vm.computedHeight,"alt":_vm.alt === null ? _vm.file.fileTitle : _vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }